export class Registration {
  email: string;
  name: string;
  surname: string;
  ssn: string;
  birthDate: string;
  birthPlace: string;
  phoneNumber: string;
  password: string;
  doctorRole: string;

  // tslint:disable-next-line:max-line-length
  constructor(email: string, name: string, surname: string, ssn: string, birthDate: string, birthPlace: string, phoneNumber: string, password: string, doctorRole: string) {
    this.email = email;
    this.name = name;
    this.surname = surname;
    this.ssn = ssn;
    this.birthDate = birthDate;
    this.birthPlace = birthPlace;
    this.phoneNumber = phoneNumber;
    this.password = password;
    this.doctorRole = doctorRole;
    // ROLES MISSING: Al momento assumiamo che si registrino solo i dottori
  }
}
